export default (): { label: string; value: string }[] => [
  { label: 'A&R ', value: 'a&r' },
  { label: 'Account Manager ', value: 'accountManager' },
  { label: 'Accountant', value: 'accountant' },
  { label: 'Admin Support ', value: 'adminSupport' },
  { label: 'Analyst', value: 'analyst' },
  { label: 'Art Director', value: 'artDirector' },
  { label: 'Artist Management', value: 'artistManagement' },
  { label: 'Assistant', value: 'assistant' },
  { label: 'Brand Partner', value: 'brandPartner' },
  { label: 'Business Development', value: 'businessDevelopment' },
  { label: 'CEO/CFO/CMO/CIO/COO', value: 'CEO/CFO/CMO/CIO/COO' },
  { label: 'Commercial', value: 'commercial' },
  { label: 'Content', value: 'content' },
  { label: 'Designer/UX/UI', value: 'Designer/UX/UI' },
  { label: 'Developer', value: 'developer' },
  { label: 'Digital', value: 'digital' },
  { label: 'E-Commerce', value: 'e-commerce' },
  { label: 'Finance', value: 'finance' },
  { label: 'General Manager', value: 'generalManager' },
  { label: 'Label Manager', value: 'labelManager' },
  { label: 'IT', value: 'it' },
  { label: 'Radio', value: 'radio' },
  { label: 'Royalities', value: 'royalities' },
  { label: 'Marketing', value: 'marketing' },
  { label: 'Managing Director', value: 'managingDirector' },
  { label: 'Merch', value: 'merch' },
  { label: 'Promotions', value: 'promotions' },
  { label: 'Product Manager', value: 'productManager' },
  { label: 'Project Manager', value: 'projectManager' },
  { label: 'President', value: 'president' },
  { label: 'Publishing', value: 'publishing' },
  { label: 'Sales', value: 'sales' },
  { label: 'Streaming', value: 'streaming' },
  { label: 'Sync', value: 'sync' },
  { label: 'Vice President', value: 'vicePresident' },
  { label: 'Not Listed', value: 'notListed' },
];
